/**
 * JavaScript Graphical User Interface
 * Defining GUI.Forms namespace
 *
 * @author Eugene Lyulka
 * @version 2.0
 * @namespace GUI
 */
GUI.Forms = {};